var React = require('react');

module.exports = React.createClass({
  render: function() {
    var baseProps = {
      'fill': '#000000',
'height': '32',
'viewBox': '0 0 24 24',
'width': '32',
'xmlns': 'http://www.w3.org/2000/svg',
      className: 'svg-icon',
      dangerouslySetInnerHTML: {
        __html: " <path d=\"M0 0h24v24H0z\" fill=\"none\"/> <path d=\"M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z\"/> ",
      }
    };
    var props = Object.assign({}, baseProps, this.props);
    return React.createElement('svg', props);
  },
});



// WEBPACK FOOTER //
// ./node_modules/dk-ui-lib/assets/done.svg